import { CSSProperties, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const iconStyle: CSSProperties = {
  marginLeft: '6px',
  fontSize: 'inherit',
  alignSelf: 'center',
};

const getBgColor = (theme, selected: boolean, secondaryNav: boolean) => {
  if (secondaryNav) {
    return selected ? theme.colors.headerSecondaryNavSelected : theme.colors.headerSecondaryNav;
  }

  return selected ? theme.colors.headerNavSelected : theme.colors.header;
};

const getHoverBgColor = (theme, selected: boolean, secondaryNav: boolean) => {
  if (secondaryNav) {
    return selected
      ? theme.colors.headerSecondaryNavSelected
      : theme.colors.headerSecondaryNavHover;
  }

  return selected ? theme.colors.headerNavSelected : theme.colors.headerNavHover;
};

const getNavFontStyle = (theme, selected: boolean, secondaryNav: boolean) => {
  if (secondaryNav) {
    return selected
      ? theme.fonts.headerSecondaryNavSelected ??
          theme.fonts.headerSecondaryNav ??
          theme.fonts.headerNav
      : theme.fonts.headerSecondaryNav ?? theme.fonts.headerNav;
  }

  return selected && theme.fonts.headerNavSelected
    ? theme.fonts.headerNavSelected
    : theme.fonts.headerNav;
};

const getHoverNavFontStyle = (theme, secondaryNav: boolean) => {
  if (secondaryNav) {
    return theme.fonts.headerSecondaryNavHover;
  }

  return theme.fonts.headerNavHover;
};

interface LinkProps {
  selected?: boolean | any;
  secondaryNav?: boolean;
  to?: string;
  children?: ReactNode;
  onClick?: any;
}

export const Link = styled(NavLink)<LinkProps>(({ theme, selected, secondaryNav }) => {
  const fontStyle = getNavFontStyle(theme, selected, secondaryNav);
  const fontHoverStyle = getHoverNavFontStyle(theme, secondaryNav);

  return css`
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 0 10px;
    transition: all 0.3s linear;
    color: inherit;

    color: ${fontStyle?.color};
    font-family: ${fontStyle?.fontFamily};
    font-size: ${fontStyle?.fontSize};
    font-weight: ${fontStyle?.fontWeight};
    font-style: ${fontStyle?.fontStyle};
    text-decoration: ${fontStyle?.textDecoration};

    &:hover {
      color: ${fontHoverStyle?.color};
      font-family: ${fontHoverStyle?.fontFamily};
      font-size: ${fontHoverStyle?.fontSize};
      font-weight: ${fontHoverStyle?.fontWeight};
      font-style: ${fontHoverStyle?.fontStyle};
      text-decoration: ${fontHoverStyle?.textDecoration};
    }

    @media (min-width: 1280px) {
      padding: 10px 16px;
    }

    @media (max-width: 990px) {
      & svg {
        font-size: 2em;
      }
    }
  `;
});

interface WrapperProps {
  selected?: boolean;
  secondaryNav?: boolean;
  display?: boolean | string;
  children?: ReactNode;
  style?: CSSProperties;
}

export const Wrapper = styled.div<WrapperProps>(({ theme, selected, secondaryNav, display }) => {
  return css`
    display: flex;
    align-items: center;
    position: relative;
    height: 100%;
    cursor: pointer;
    background-color: ${getBgColor(theme, selected, secondaryNav)};

    &:hover {
      background-color: ${getHoverBgColor(theme, selected, secondaryNav)};
    }

    ${secondaryNav &&
    css`
      padding: 0px 4px;
    `}

    ${!display &&
    css`
      display: none;
    `}
  `;
});

interface LinkTextProps {
  isTextHidden?: boolean;
  children?: ReactNode;
}

export const LinkText = styled.span<LinkTextProps>`
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;

  @media (max-width: 990px) {
    ${({ isTextHidden }) =>
      isTextHidden &&
      css`
        display: none;
      `}
  }
`;
